import { Box, Typography } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { PopupPageStyle } from "../../../../utils/Styles.utils";
import { capitalizeFirstLetter } from "../../../../utils/Utils";
import AppButton from "../../../base/AppButton.component";
import { useRef, useState } from "react";
import HocPopup from "../../../../hoc/hocPopup";
import { PopupStyles } from "./CustomerDetailsStyles";
import CustomerDetailTabContent from "./CustomerDetailTabContent";

const CustomerDetailsPopup = ({ customer }) => {
  const printRef = useRef();
  const [tabValue, setTabValue] = useState(1);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: PopupPageStyle,
  });

  const TableContent = () => (
    <Box sx={PopupStyles.cardBox}>
      <Box sx={PopupStyles.itemBox}>
        <span>Name</span>
        <span style={PopupStyles.itemStyle}>
          {`${capitalizeFirstLetter(
            customer.customer.first_name,
          )} ${capitalizeFirstLetter(customer.customer.last_name)}`}
        </span>
      </Box>
      <Box sx={PopupStyles.itemBox}>
        <span>Email</span>
        <span style={PopupStyles.itemStyle}>{customer.contact.email}</span>
      </Box>
      <Box sx={PopupStyles.itemBox}>
        <span>Phone Number</span>
        <span style={PopupStyles.itemStyle}>
          {customer.contact.mobile_number}
        </span>
      </Box>
    </Box>
  );

  // Warranty tab has its own Print on the chart — hide the popup Print there.
  const showPopupPrint = tabValue !== 4;

  return (
    <>
      <Box sx={PopupStyles.mainBox}>
        <TableContent />
        <CustomerDetailTabContent
          customer={customer}
          tabValue={tabValue}
          onTabChange={setTabValue}
        />
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: "-10000px",
          top: 0,
          width: "800px",
          background: "#fff",
        }}
        ref={printRef}
      >
        <Typography p={2}>Customer Details:</Typography>
        <TableContent />
        <CustomerDetailTabContent
          customer={customer}
          tabValue={tabValue}
          onTabChange={() => {}}
          printMode
        />
      </Box>

      {showPopupPrint ? (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <AppButton
            buttonText="Print"
            clickHandler={handlePrint}
            size="small"
            variant="contained"
            sx={{
              mx: "auto",
              width: "30%",
              marginTop: "16px",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </Box>
      ) : null}
    </>
  );
};

export default HocPopup(CustomerDetailsPopup);
